module.exports = __webpack_public_path__ + "static/eye-sculpture-trail-social-c1925a3afe18764a24ea2d4ce6b306df.png";